module.exports = __webpack_public_path__ + "img/wz-7-2-4.fa27def3.jpg";